import { closeModal } from "react-url-modal";
import { useNavigate } from "react-router";
import { WindowNames } from "@/resources/constants";
import { CommonErrorModal, PassChangeModal } from "@/components";
import { ModalTexts } from "@/resources/locale";
import { LoginModalPropsType } from "./types";
import {
  AuthModal,
  AuthErrorModal,
  CodeModal,
  RegistrationModal,
  RegistrationSuccessModal,
} from "./components";
import { useModalNavigation } from "./hooks/useModalNavigation";

export const LoginModal = (props: LoginModalPropsType) => {
  const { setIsOpen } = props;
  const { showWindow, showForm } = props.params;
  const { handleClose } = useModalNavigation();
  const navigate = useNavigate();

  const isOpen = true;

  const renderModal = () => {
    switch (showWindow) {
      case WindowNames.AUTH:
        return (
          <AuthModal
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            onClose={() => navigate(-1)}
          />
        );
      case WindowNames.AUTH_ERROR:
        return (
          <AuthErrorModal
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            onClose={() => navigate(-1)}
          />
        );
      case WindowNames.REGISTRATION:
        return (
          <RegistrationModal
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            onClose={() => closeModal()}
          />
        );
      case WindowNames.CODE:
        return (
          <CodeModal
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            onClose={() => navigate(-1)}
          />
        );
      case WindowNames.FORGOT_PASS:
        return (
          <PassChangeModal
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            title={ModalTexts.changePass.inputPhone.recovery.TITLE}
            subTitle={ModalTexts.changePass.inputPhone.recovery.SUB_TITLE}
            forcedShowForm={showForm}
            closeModal={() => closeModal()}
          />
        );
      case WindowNames.REGISTRATION_SUCCESS:
        return (
          <RegistrationSuccessModal
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            onClose={() => closeModal()}
          />
        );
      case WindowNames.ERROR:
        return (
          <CommonErrorModal
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            closeFunc={() => closeModal()}
          />
        );
      default:
        return null;
    }
  };

  return <>{renderModal()}</>;
};
